var _path, _path2, _path3, _path4;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEmojiSad = function SvgEmojiSad(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75 113.75H45C17.85 113.75 6.25 102.15 6.25 75V45C6.25 17.85 17.85 6.25 45 6.25H75C102.15 6.25 113.75 17.85 113.75 45V75C113.75 102.15 102.15 113.75 75 113.75ZM45 13.75C21.95 13.75 13.75 21.95 13.75 45V75C13.75 98.05 21.95 106.25 45 106.25H75C98.05 106.25 106.25 98.05 106.25 75V45C106.25 21.95 98.05 13.75 75 13.75H45Z",
    fill: "#434958"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42 92.249H78C82.55 92.249 86.25 88.549 86.25 83.999C86.25 69.549 74.5 57.749 60 57.749C45.5 57.749 33.75 69.549 33.75 83.999C33.75 88.549 37.45 92.249 42 92.249ZM60 65.249C70.35 65.249 78.75 73.649 78.75 83.999C78.75 84.399 78.4 84.749 78 84.749H42C41.6 84.749 41.25 84.399 41.25 83.999C41.25 73.649 49.65 65.249 60 65.249Z",
    fill: "#434958"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.799 47.5021C65.849 47.5021 64.899 47.1521 64.149 46.4021C62.699 44.9521 62.699 42.5521 64.149 41.1021C70.599 34.6521 81.149 34.6521 87.649 41.1021C89.099 42.5521 89.099 44.9521 87.649 46.4021C86.199 47.8521 83.799 47.8521 82.349 46.4021C78.799 42.8521 72.999 42.8521 69.449 46.4021C68.749 47.1521 67.799 47.5021 66.799 47.5021Z",
    fill: "#434958"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2022 47.5021C52.2522 47.5021 51.3022 47.1521 50.5522 46.4021C47.0022 42.8521 41.2022 42.8521 37.6522 46.4021C36.2022 47.8521 33.8021 47.8521 32.3521 46.4021C30.9021 44.9521 30.9021 42.5521 32.3521 41.1021C38.8021 34.6521 49.3522 34.6521 55.8522 41.1021C57.3022 42.5521 57.3022 44.9521 55.8522 46.4021C55.1022 47.1521 54.1522 47.5021 53.2022 47.5021Z",
    fill: "#434958"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmojiSad, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/emoji-sad.886dc3d9.svg";
export { ForwardRef as ReactComponent };